const messages = {
  step3: {
    actionBtn: "Prihlásiť sa",
  },
};

export default {
  messages,
};
